import React from 'react';

const slide = ( props ) => {
	let slideClass = 'Slide';
	if( props.id === props.selectedSlide ) {
		slideClass += ' selected';
	}
	else if( props.id < props.selectedSlide ) {
		slideClass += ' moveRight';
	}
	
	let content = null;
	if( props.content ) {
		content = {
			__html: props.content
		};
	}
	
	let slideStyle = {};
	
	if( props.bgImage ) {
		slideStyle.backgroundImage = 'url( ' + props.bgImage + ')';
	}
	
	return (
		<div className={ slideClass } dangerouslySetInnerHTML={ content } style={ slideStyle } />
	);
};

export default slide;



// WEBPACK FOOTER //
// ./src/components/Slideshow/Slide.js